export class InvalidJwtTokenError extends Error {
  constructor() {
    super('Invalid decoded JWT token');
  }
}
